import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { GetUserGroupsResponse } from '~types/api/user';

export function useGetUserGroups() {
  return useQuery<GetUserGroupsResponse, Error>('userGroups', async () => {
    const token = useUserStore.getState().token;
    const user = useUserStore.getState().user;

    const response = await fetch(`${BASE_API_URL}users/${user?.uid}/groups`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user groups');
    }

    const data = await response.json();

    return data as GetUserGroupsResponse;
  });
}
